import { useMemo } from "react";
import { useGuestCheckoutSettings } from "../context/GuestCheckoutSettingsContext";
import { resolveWidgetLocale } from "../../utils/widgetLocale";

/**
 * The widget's formatting locale (browser first, then the venue's), or
 * `undefined` outside the widget so the full app keeps its own locale rules.
 */
export function useWidgetLocale(venueCountryCode?: string | null): string | undefined {
  const { isWidget } = useGuestCheckoutSettings();
  return useMemo(() => (isWidget ? resolveWidgetLocale(venueCountryCode) : undefined), [isWidget, venueCountryCode]);
}

/**
 * The locale to format with: the widget's browser (or venue) locale in the
 * widget, otherwise `appLocale`, the full app's own locale.
 */
export function useFormattingLocale(
  venueCountryCode: string | null | undefined,
  appLocale?: string,
): string | undefined {
  const { isWidget } = useGuestCheckoutSettings();
  const widgetLocale = useWidgetLocale(venueCountryCode);
  return isWidget ? widgetLocale : appLocale;
}
